import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, AUTH_MODE } from '../auth/firebase.js';
export function useSchoolAccess(uid) {
    const [school, setSchool] = useState(null), [member, setMember] = useState(null), [now, setNow] = useState(Date.now());
    useEffect(() => {
        setSchool(null); setMember(null);
        if (!db || !uid || AUTH_MODE === 'mock') return;
        let stopSchool = () => {}, stopMember = () => {};
        const stop = onSnapshot(doc(db, 'users', uid, 'private', 'schoolAccess'), snap => {
            stopSchool(); stopMember(); setSchool(null); setMember(null);
            const id = snap.data()?.schoolId; if (!id) return;
            stopMember = onSnapshot(doc(db, 'schools', id, 'members', uid), s => setMember(s.data() || null), () => setMember(null));
            stopSchool = onSnapshot(doc(db, 'schools', id), s => setSchool(s.data() || null), () => setSchool(null));
        }, () => { setSchool(null); setMember(null); });
        const timer = setInterval(() => setNow(Date.now()), 30000);
        return () => { stop(); stopSchool(); stopMember(); clearInterval(timer); };
    }, [uid]);
    return school?.enabled && member?.enabled && school.startsAt?.toMillis() <= now && school.expiresAt?.toMillis() > now ? school : null;
}
